import { createContext, PropsWithChildren, useEffect, useState } from "react";

import {
  CardSavingType,
  OrgSettings,
  SavedCardPaymentFlow,
} from "~/entities/baseEntities";
import { storage } from "~/storage";

interface SettingContextType {
  orgSettings: OrgSettings;
  address: string;
  setAddress: (value: string) => void;
  multiSite: boolean;
}

const SettingsContext = createContext<SettingContextType>({
  orgSettings: {
    customerSignInOptions: {
      passwordless: { email: false, sms: false },
      signInWith: { google: false, apple: false },
      smsAllowedCountryCodes: [],
    },
    loyaltySettings: {
      promotionName: "",
      loyaltyLink: "",
      loyaltyName: "",
      required: false,
      loyaltyIcon: null,
      balanceUnitName: "",
      balanceIsMonetary: false,
    },
    giftCardSettings: {
      expirationDays: null,
    },
    paymentSettings: {
      cardSavingType: CardSavingType._NOT_SET,
      savedCardPaymentFlow: SavedCardPaymentFlow._NOT_SET,
    },
  },
  address: "",
  multiSite: false,
  setAddress: () => null,
});

interface SettingContextDataProps {
  orgSettings: OrgSettings;
  multiSite: boolean;
}

export const SettingsContextProvider = ({
  children,
  orgSettings,
  multiSite,
}: PropsWithChildren<SettingContextDataProps>) => {
  const [address, setAddress] = useState<string>(storage.get("address") ?? "");

  useEffect(() => {
    storage.set("address", address);
  }, [address]);

  return (
    <SettingsContext.Provider
      value={{
        orgSettings,
        address,
        setAddress,
        multiSite,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
